module.exports = __webpack_public_path__ + "static/section-img@2x-b7a53c60ba384330a9ce488e4da3aae8.png";